var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-[34px] h-[34px] rounded-full flex justify-center items-center",style:(`background-color: ${_vm.badgeBg}`)},[_c(_vm.iconComponent,{tag:"Component",attrs:{"size":20,"color":"#000"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }